export const INTRO_DURATION_MS = 15000;
export const INTRO_HEART_COUNT = 8;
export const INTRO_HEART_SIZES = [15, 21, 29, 37, 47, 37, 29, 21];
export const INTRO_HEART_CONTAINER_SIZES = [24, 30, 38, 48, 60, 48, 38, 30];
export const INTRO_HEART_ITEMS = Array.from(
	{ length: INTRO_HEART_COUNT },
	(_, index) => ({
		id: `heart-${index + 1}`,
		containerSize: INTRO_HEART_CONTAINER_SIZES[index],
		index,
		heartSize: INTRO_HEART_SIZES[index]
	})
);
export const INTRO_IMAGE_SRC =
	'https://cdn.newo.ai/static-images/ionos-emily.png';
export const READY_TRANSITION_DURATION_MS = 1200;
export const IMAGE_ASPECT_RATIO = 660 / 760;
export const EMILY_STAGE_HEIGHT_RATIO = 0.972;
export const CREATOR_SHELL_HEADER_HEIGHT = 112;
export const FALLBACK_VIEWPORT_WIDTH = 1440;
export const FALLBACK_VIEWPORT_HEIGHT = 900;
export const WEB_CALL_CUSTOMER_IDN = 'NEPhtF1UHA';
export const WEB_CALL_NEWO_CUSTOMER_IDN = 'NEpBrxkpc2';
export const WEB_CALL_CONNECTOR_IDN = 'newo_voice_connector';
export const CREATOR_CHAT_FLOW_RECEPTIONIST_CREATED_STORAGE_KEY =
	'creator-chat-flow:is-receptionist-created';
export const CREATOR_CHAT_FLOW_CALL_STARTED_STORAGE_KEY =
	'creator-chat-flow:has-started-call';
export const CREATOR_CHAT_FLOW_CHAT_SHOWN_STORAGE_KEY =
	'creator-chat-flow:chat-shown';
